export interface User {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
    createdAt: string;
    updatedAt: string;
}

export interface MinimalAppConfig {
    miniOSVersion: string;
    // Legacy versionCode-based gate, still read by older app builds.
    minAndroidBuildVersion: number;
    // versionName-based gate (e.g. "7.1.0") read by newer app builds.
    minAndroidVersionName: string;
}

export interface CarwashCustomerServiceStatus {
    status: string;
}

export interface FeatureFlags {
    id: number;
    name: string;
    description: string | null;
    iosMinimalVersion: string | null;
    androidMinimalVersion: string | null;
    createdAt: string;
    active: boolean;
    activeForTesters?: boolean | null;
}

export type SupportedLanguage = 'en' | 'fr';

export type TranslationMap = {
    [key in SupportedLanguage]: string;
};

type Nullable<T> = {
    [P in keyof T]: T[P] | null;
};

export type NullableTranslationMap = Nullable<TranslationMap>;

export const SupportedLanguages: SupportedLanguage[] = ['en', 'fr'];

export type PaginatedList<Elem> = {
    page: number;
    perPage: number;
    total: number;
    results: Elem[];
};

export type CsvContent = {
    [key: string]: string | number | boolean | null | undefined;
}[];
export interface Checkboxes {
    id: number | null;
    isMandatory: boolean | null;
    deletedAt?: string | null;
    translations: TranslationMap;
}

export interface CmsUserHistory {
    email: string | null;
    action: string;
    createdAt: string;
}

export interface StoreChangeHistory {
    id: number;
    storeId: number;
    storeNref: string | null;
    action: 'added' | 'modified' | 'deleted';
    beforeValues: Record<string, unknown> | null;
    afterValues: Record<string, unknown> | null;
    cmsUserEmail: string;
    createdAt: string;
}

export enum HttpMethod {
    GET = 'GET',
    POST = 'POST',
    PUT = 'PUT',
    DELETE = 'DELETE',
    PATCH = 'PATCH',
}

export enum OperationStatus {
    SUCCESS = 'success',
    ERROR = 'error',
}

export type UpsertSkippedReason = 'brand-mismatch' | 'not-found';

export interface UpsertSkippedEntry {
    id: number | null;
    nref: string | null;
    reason: UpsertSkippedReason;
    existingBrand?: string;
}

export interface UpsertStoresResponse {
    applied: { added: number; modified: number };
    skipped: UpsertSkippedEntry[];
}

/**
 * The result of a confirmed action in a ConfirmationModal. Absent means it
 * succeeded; `message` carries the server's own wording so the dialog can name
 * the reason rather than falling back to a generic string.
 */
export interface ConfirmOutcome {
    ok: boolean;
    message?: string;
}
